<template>
  <div :id="random_id" :data-testid="props.dataTestid" v-if="props.data && props.data.length > 0"
    class="deals-and-offers-carousel">
    <TsCarouselV2 v-bind="$attrs">
      <TsCarouselSlide
          v-for="deal in props.data"
          :key="deal.id"
          append-class="flex-[0_0_calc(100%/1)] sm:flex-[0_0_calc(100%/2)] md:flex-[0_0_calc(100%/3)] lg:flex-[0_0_calc(100%/4)]"
      >
        <TsCardDealsAndOffers :variant="deal.variant" :coupon-code="deal.couponCode" :image="deal.image"
          :promo-text="deal.promoText" :title="deal.title" :configuration="deal.configuration" />
      </TsCarouselSlide>
    </TsCarouselV2>
  </div>
</template>

<script setup lang="ts">

const TsCarouselV2 = defineAsyncComponent(
    () => import('~/components/organisms/TsCarouselV2.vue')
);

const TsCarouselSlide = defineAsyncComponent(
    () => import('~/components/organisms/TsCarouselSlide.vue')
);

const TsCardDealsAndOffers = defineAsyncComponent(
    () => import('~/components/molecules/TsCardDealsAndOffers.vue')
);

defineOptions({
  inheritAttrs: false,
});

type Props = {
  dataTestid?: string;
  data?: object[];
}

const props = withDefaults(defineProps<Props>(), {
  data: () => ([
    {
      id: 1,
      variant: "blue",
      couponCode: "FLATDEAL",
      image: "/images/deals-and-offers-1.png",
      promoText: "Tool Up for Savings",
      title: "Grab Your Gear Now!",
      configuration: "Triton JOF001 router 1,010W 6-12mm"
    },
    {
      id: 2,
      variant: "yellow",
      couponCode: "FLATDEAL",
      image: "/images/deals-and-offers-2.png",
      promoText: "Tool Up for Savings",
      title: "Grab Your Gear Now!",
      configuration: "Milwaukee Li-ion battery 12V Li-ion"
    },
    {
      id: 3,
      variant: "red",
      couponCode: "FLATDEAL",
      image: "/images/deals-and-offers-3.png",
      promoText: "Tool Up for Savings",
      title: "Grab Your Gear Now!",
      configuration: "Triton JOF001 router 1,010W 6-12mm"
    },
    {
      id: 4,
      variant: "black",
      couponCode: "FLATDEAL",
      image: "/images/deals-and-offers-4.png",
      promoText: "Tool Up for Savings",
      title: "Grab Your Gear Now!",
      configuration: "Milwaukee Li-ion battery 12V Li-ion"
    }
  ])
});

const random_id = ref("");

onMounted(() => {
  random_id.value = useRandomUUID();
})
</script>
